import { MetaDefinition } from '@angular/platform-browser';
import { ResolveFn } from '@angular/router';

export const websiteMetaResolver: ResolveFn<{ tags: MetaDefinition[] }> = () => {
  return {
    tags: [
      { name: 'copyright', content: 'Nusign AG' },
      { name: 'apple-mobile-web-app-title', content: 'Picflow' },
      { name: 'mobile-web-app-capable', content: 'yes' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'white' },
      { property: 'fb:app_id', content: '861804031074445' },
      { property: 'og:site_name', content: 'Picflow' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:site', content: '@PicflowHQ' },
      {
        name: 'google-signin-client_id',
        content: '387343500342-obn0crc436d0kubai59g2frmat1sbmvl.apps.googleusercontent.com',
      },
    ],
  };
};
